import { createTheme } from "../utils/create-theme";
export var OC_THEME = createTheme('oc', {
  activeMode: 'light',
  light: {
    color: {
      lineMid: '#00000022',
      appChrome: '#F5F5F5',
      primary: '#2565c7',
      secondary: '#FCB017',
      primaryDarker: '#2058ae',
      primaryLight: '#82b2fb',
      primaryLighter: '#c0d8fd',
      primaryBright: '#2e7ef9',
      primaryVeryLight: '#eaf2fe',
      link: '#2565c7',
      linkHover: '#000000',
      navigationActive: '#2565c7',
      accentDark: '#2058ae',
      accentLight: '#82b2fb'
    }
  },
  dark: {
    color: {
      linkHover: '#528EC8'
    }
  }
});
export default OC_THEME;